// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"96":"55165b3744e7706a","240":"b9db485935e67dd6","736":"6c65347cb84e4130"}[chunkId] + ".js";
};